// index.js
import React, { useState, useEffect } from "react";
import { useNavigate, Link, useSearchParams } from "react-router-dom";
import { Avatar } from "antd";
import {
  AppstoreOutlined,
  MailOutlined,
  SettingOutlined,
} from "@ant-design/icons";
import axiosInstance from "@/axios/axiosInstance";
import { Menu } from "antd";
import "./index.scss";

import Paper from "./right/paper";
import Video from "./right/video";
import Tutorial from "./right/tutorial";
import Userinfor from "../userinfor";

import Computing from "./right/Computing";
import Dataset from "./right/Dataset";
import Service from "./right/Service";
import ComputeOrder from "./right/computeOrder/computeOrder";
import Recharge from "./right/finance/recharge";

function getItem(label, key, icon, children, type) {
  return {
    key,
    icon,
    children,
    label,
    type,
  };
}

function maskPhoneNumber(phoneNumber) {
  if (phoneNumber && phoneNumber.length !== 11) {
    return "无效的电话号码";
  }

  const prefix = phoneNumber && phoneNumber.slice(0, 3);
  const suffix = phoneNumber && phoneNumber.slice(7);
  const masked = prefix + "****" + suffix;

  return masked;
}

const items = [
  getItem("内容中心", "sub1", <MailOutlined />, [
    getItem("视频内容", "1"),
    getItem("教程内容", "2"),
    getItem("论文内容", "3"),
  ]),
  getItem("Ai交易所", "sub2", <AppstoreOutlined />, [
    getItem("算力管理", "4"),
    getItem("数据集管理", "5"),
    getItem("服务管理", "6"),
  ]),
  getItem("用户管理", "user"),
  {
    type: "divider",
  },
  getItem("采购订单", "sub3", <SettingOutlined />, [
    getItem("算力购买订单", "66"),
    getItem("数据集购买订单", "7"),
    getItem("其他订单", "8"),
  ]),
  getItem("销售订单", "sub35", <SettingOutlined />, [
    getItem("算力购销售订单", "665"),
    getItem("数据集购销售订单", "75"),
    getItem("其他订单", "85"),
  ]),
  getItem("财务中心", "sub22", <AppstoreOutlined />, [
    getItem("充值", "10"),
    getItem("开支", "61"),
  ]),
  {
    type: "divider",
  },
  getItem("消息中心", "sub23", <AppstoreOutlined />, [
    getItem("消息1", "11"),
    getItem("消息2", "12"),
  ]),
  {
    type: "divider",
  },
  getItem(<Link to="/userInfor">账号管理</Link>),
];

const Personal = () => {
  const navigate = useNavigate();
  const [searchParams, setSearchParams] = useSearchParams();
  const [selectedKey, setSelectedKey] = useState(
    searchParams.get("selectedKey") || "1"
  );
  const [openKeys, setOpenKeys] = useState(
    searchParams.getAll("openKeys").length > 0
      ? searchParams.getAll("openKeys")
      : ["sub1"]
  );
  const [userData, setUserData] = useState({});

  const fetchUserInfo = async () => {
    try {
      const response = await axiosInstance.get(`/account/detail`);
      if (response.data.data) {
        setUserData(response.data.data);
      } else {
        navigate("/login");
      }
    } catch (error) {
      console.error("Error fetching user info:", error);
    }
  };

  useEffect(() => {
    fetchUserInfo();
  }, []);

  useEffect(() => {}, []);

  const handleMenuClick = (e) => {
    setSelectedKey(e.key);
    setSearchParams({ selectedKey: e.key, openKeys: getOpenKeys(e.key) });
  };

  const getOpenKeys = (key) => {
    let newOpenKeys = [...openKeys];
    if (key.startsWith("sub")) {
      if (newOpenKeys.includes(key)) {
        newOpenKeys = newOpenKeys.filter((k) => k !== key);
      } else {
        newOpenKeys.push(key);
      }
    } else {
      const parentKey = items.find((item) =>
        item.children?.some((child) => child.key === key)
      )?.key;
      if (parentKey && !newOpenKeys.includes(parentKey)) {
        newOpenKeys.push(parentKey);
      }
    }
    return newOpenKeys;
  };

  const renderContent = () => {
    switch (selectedKey) {
      case "1":
        return <Video />;
      case "2":
        return <Tutorial />;
      case "3":
        return <Paper />;
      case "user":
        return <Userinfor userData={userData} fetchUserInfo={fetchUserInfo} />;
      case "4":
        return <Computing />;
      case "5":
        return <Dataset />;
      case "6":
        return <Service />;
      case "66":
        return "默认内容";
      // return <ComputeOrder />;
      case "10":
        return "默认内容";
      // return <Recharge />;
      default:
        return <div>默认内容</div>;
    }
  };

  let profilePictureUrl = userData ? userData.profilePictureUrl : "";
  return (
    <div className="personal_content">
      <div className="content">
        <div className="content_top">
          <Avatar
            size={64}
            src={`/file/${profilePictureUrl}`}
            className="photo"
          />
          <div className="user_por">
            <div>{maskPhoneNumber(userData?.phone)}</div>
            <div>
              性别：{userData?.sex === 2 ? "女" : "男"} 工作年限：
              {userData?.workYears ? `${userData?.workYears}年` : "未知"}
            </div>
          </div>
        </div>
        <div className="content_bot">
          <div className="content_bot_lef">
            <Menu
              onClick={handleMenuClick}
              style={{ width: 256 }}
              selectedKeys={[selectedKey]}
              openKeys={openKeys}
              onOpenChange={(keys) => setOpenKeys(keys)}
              mode="inline"
              items={items}
            />
          </div>
          <div className="content_bot_rig ">{renderContent()}</div>
        </div>
      </div>
    </div>
  );
};

export default Personal;
